import type { ReactNode } from "react";
import {
	BASE_MORTGAGE_CALCULATOR_URL,
	BORDER_FOR_JTM_RULE,
	HIGHER_INTEREST_ANNUAL,
	HIGHER_JTM_RULE,
	LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS,
	LOWER_INTEREST_ANNUAL,
	LOWER_JTM_RULE,
	MORTGAGE_HOW_MUCH_CALCULATOR_URL,
} from "./data";

function calculateTotalRepaymentWithHigherInterest(loanAmount: number): number {
	const interest = HIGHER_INTEREST_ANNUAL / 12;
	const monthlyRepayment =
		(loanAmount * (interest * (1 + interest) ** LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS)) /
		((1 + interest) ** LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS - 1);

	return monthlyRepayment * LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS;
}
export function calculateTotalRepaymentWithLowerInterest(loanAmount: number): {
	monthlyInstallment: number;
	totalRepayment: number;
} {
	const interest = LOWER_INTEREST_ANNUAL / 12;
	const monthlyRepayment =
		(loanAmount * (interest * (1 + interest) ** LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS)) /
		((1 + interest) ** LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS - 1);

	return {
		monthlyInstallment: monthlyRepayment,
		totalRepayment: monthlyRepayment * LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS,
	};
}
export function calculateTotalRepaymentDifference(loanAmount: number): number {
	return (
		calculateTotalRepaymentWithHigherInterest(loanAmount) -
		calculateTotalRepaymentWithLowerInterest(loanAmount).totalRepayment
	);
}

export function isKOResult(
	loanAmount: number,
	monthlyIncome: number,
	wantsFirstHouse: boolean,
	has2YearsLegalHealthInsurance: boolean,
): { isKO: boolean; koMessage: ReactNode; redirectionUrl: string } {
	const monthlyInstallment = calculateTotalRepaymentWithLowerInterest(loanAmount).monthlyInstallment;
	const koValues = { isKO: false, koMessage: <></>, redirectionUrl: "" };

	if (!wantsFirstHouse) {
		koValues.isKO = true;
		koValues.koMessage = (
			<div className="text-left">
				<p>
					A támogatott hitelt kizárólag első lakás vásárlására lehet fordítani. Nem kaphatod meg a kölcsönt,
					amennyiben jelenleg van (vagy 10 éven belül volt) belterületi lakóingatlanod.
				</p>
				<p>Nem probléma ha:</p>
				<ul>
					<li>a meglévő/korábbi ingatlan, ha annak értéke nem haladja meg a 15 millió Ft-ot.</li>
					<li>ha a korábbi ingatlant elbontották.</li>
					<li>
						ha az ingatlant haszonélvezettel terhelten szerezted és a haszonélvező bent lakik a lakásban.
					</li>
					<li>
						ha egyidejűleg legfeljebb egy belterületi lakóingatlanban van/volt 50%-ot meghaladó
						tulajdonrészed.
					</li>
				</ul>
			</div>
		);
		koValues.redirectionUrl = BASE_MORTGAGE_CALCULATOR_URL;
	}

	if (!has2YearsLegalHealthInsurance) {
		koValues.isKO = true;
		koValues.koMessage = (
			<div>
				A támogatott hitel felvételéhez legalább 2 éves TB jogviszonnyal kell rendelkezned.Ez jellemzően
				munkaviszonyt, vállalkozói múltat takar, de a jogviszony másképp is teljesíthető.
			</div>
		);
		koValues.redirectionUrl = BASE_MORTGAGE_CALCULATOR_URL;
	}

	if (
		(monthlyIncome < BORDER_FOR_JTM_RULE && monthlyIncome * LOWER_JTM_RULE < monthlyInstallment) ||
		(monthlyIncome > BORDER_FOR_JTM_RULE && monthlyIncome * HIGHER_JTM_RULE < monthlyInstallment)
	) {
		koValues.isKO = true;
		koValues.koMessage = (
			<div>
				A jövedelmed nem elégséges az igényelt kölcsön törlesztőrészletének megfizetéséhez. (A fizetésed
				legfeljebb 50/60 százaléka fordítható a kölcsön törlesztésére.)
			</div>
		);
		koValues.redirectionUrl = MORTGAGE_HOW_MUCH_CALCULATOR_URL;
	}

	return koValues;
}
